export const connectorTypes = {
    loading: "LOADING_CONNECTOR",
    delete: "DELETE_CONNECTOR",
    loadedOne: "LOADED_CONNECTOR",
    loadedMultiple: "LOADED_CONNECTORS",
    success: "SUCCESS_CONNECTOR",
    restore: "RESTORE_CONNECTOR",
    hardDelete: "HARDDELETE_CONNECTOR",
};
